import { Box, Typography } from '@mui/material';
import React from 'react';
import { ReactComponent as LocationIcon } from '../../images/report-sidebar/locations.svg';
import { Tooltip } from '@cellebrite/saas-ui-common';

interface LocationTagProps {
    address: string;
    icon?: any;
}

const LocationTag: React.FC<LocationTagProps> = ({ address, icon }) => {
    return (
        <Box
            sx={{
                height: 40,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                p: '8px 14px',
                width: 'max-content',
                maxWidth: '100%',
                whiteSpace: 'nowrap',
            }}
            className="background-color-bd-opacity"
        >
            {icon ? icon : <LocationIcon className="fill-l" />}
            <Tooltip placement="bottom-end" content={<Typography className="color-mh">{address}</Typography>}>
                <Typography
                    variant="s14w700"
                    className="color-l"
                    sx={{ ml: 1, width: 'calc(100% - 14px)', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    {address}
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default LocationTag;
